module.exports = __webpack_public_path__ + "img/ico_haeder06.87878e6.svg";